import React from 'react';
import PropTypes from 'prop-types';

import { registerDecoration } from 'core/forms';

import { Button, ButtonGroup } from 'uikit/buttons';

import styles from '../styles/formDecorationButtons.module.scss';

const FormDecorationButtons = (props) => (
  <ButtonGroup className={styles.element}>
    {props.schema.buttons?.map((button) => (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <Button {...button} key={button.text} onClick={() => button.onClick(props)} />
    ))}
  </ButtonGroup>
);

FormDecorationButtons.propTypes = {
  schema: PropTypes.shape({
    buttons: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

registerDecoration('Buttons', FormDecorationButtons);

export default FormDecorationButtons;
